import { apiSlice } from "../../app/api/apiSlice";

export const fileManagerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFileStructure: builder.query({
      query: () => ({
        url: "/files",
        validateStatus: (response, result) =>
          response.status === 200 && !result.isError,
      }),
    }),
    uploadFile: builder.mutation({
      query: (d) => ({
        url: `/files/uploadfile/${d.fileId}`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data;",
        },
        body: d.formData,
        formData: true,
      }),
    }),
    createNewFileData: builder.mutation({
      query: (data) => ({
        url: "/files/filedata",
        method: "POST",
        body: data,
      }),
    }),
    initializeQMFolder: builder.mutation({
      query: (data) => ({
        url: "/files/initialize",
        method: "POST",
        body: data,
      }),
    }),
    deleteQMStructure: builder.mutation({
      query: (data) => ({
        url: "/files/deleteqmstructure",
        method: "DELETE",
        body: data,
        invalidatesTags: ["File"],
      }),
    }),
    deleteQMFolder: builder.mutation({
      query: (data) => ({
        url: `/files/folders/delete`,
        method: "DELETE",
        body: data, // `{ folderPath, officeRef }`
        invalidatesTags: ["File"],
      }),
    }),
    moveFile: builder.mutation({
      query: ({ fileId, targetFolderId, officeRef }) => ({
        url: `/files/move`,
        method: "POST",
        body: { fileId, targetFolderId, officeRef },
        invalidatesTags: ["File"],
      }),
    }),
    addFolder: builder.mutation({
      query: (newFolder) => ({
        url: `/files/newfolder`,
        method: "POST",
        body: newFolder,
        invalidatesTags: ["File"],
      }),
    }),
  }),
});

export const {
  useGetFileStructureQuery,
  useUploadFileMutation,
  useCreateNewFileDataMutation,
  useInitializeQMFolderMutation,
  useDeleteQMStructureMutation,
  useDeleteQMFolderMutation,
  useMoveFileMutation,
  useAddFolderMutation,
} = fileManagerApiSlice;
